/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
import InvoiceTrialAPI from '@/api/InvoiceTrialAPI.js';
import InvoiceTrialSupportAPI from '@/api/InvoiceTrialSupportAPI.js';

export default {
	getInvoicesById: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: InvoiceTrialAPI.getAPIUrl() + `/${payload}`,
			headers: {
				ClientId: window.__env.authConfig.client_id_trial
			}
		});
		if (res) {
			return res;
		}
		return null;
	},

	getInvoicePdf: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: InvoiceTrialAPI.getAPIUrl() + `/${payload.InvoiceId}` + `/pdf`,
			responseType: 'arraybuffer',
			headers: {
				ClientId: window.__env.authConfig.client_id_trial
			}
		});

		if (res && res instanceof ArrayBuffer) {
			return res;
		}

		return null;
	},

	sendEmailInvoiceTrial: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: InvoiceTrialAPI.getAPIUrl() + `/send-result`,
			headers: {
				ClientId: window.__env.authConfig.client_id_trial
			},
			data: payload
		});

		return res;
	},

	pushCustomerInfo: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: InvoiceTrialSupportAPI.getAPIUrl() + `/push-info`,
			headers: {
				ClientId: window.__env.authConfig.client_id_trial
			},
			data: payload
		});

		return res;
	}
};
